// removed by extract-text-webpack-plugin
module.exports = {"Button":"G3RTChZs","Button--primary":"SfRKcb-E","Button--seconday":"_15rraTvM","Button--error":"_2g9iIyDu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button/button/button-component.styles.scss
// module id = 222
// module chunks = 0